import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-order-progress-bar',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="order-progress-container">
      <div class="progress-track">
        <div class="progress-fill" [style.width.%]="fillWidth"></div>
        <div *ngFor="let step of steps; let i = index" 
             class="progress-step" 
             [class.active]="i <= activeStepIndex"
             [class.current]="i === activeStepIndex">
          <div class="step-dot">
            <span class="material-symbols-rounded" *ngIf="i < activeStepIndex">check</span>
          </div>
          <span class="step-label">{{ step }}</span>
        </div>
      </div>
    </div>
  `,
    styleUrls: ['./order-progress-bar.component.css']
})
export class OrderProgressBarComponent {
    @Input() steps: string[] = [];
    @Input() activeStepIndex: number = 0;

    get fillWidth(): number {
        if (this.steps.length <= 1) return 0;
        const idx = Math.min(Math.max(0, this.activeStepIndex), this.steps.length - 1);
        return (idx / (this.steps.length - 1)) * 100;
    }
}
